import { UserRole } from "@sso/constant";
import { UserListExtraInfo } from "@sso/types";

const findSsoRole = (roles: UserListExtraInfo[]): UserListExtraInfo => {
  const ssoRole = roles.find(role => Object.values(UserRole).includes(role.id as UserRole));
  return ssoRole || { id: UserRole.PUBLIC, name: "Public" };
};

export { findSsoRole };
